/*
 * MDB shim for MDBSelectOptions
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 */

import MUIBox from "@mui/material/Box";

/*
 * Non-obvious mapping note:
 * MDBSelectOptions is a composition container around option children.
 * This shim intentionally uses a neutral Box wrapper for structure only.
 */
export default function MDBSelectOptions({ children, ...rest }) {
  return <MUIBox {...rest}>{children}</MUIBox>;
}
